(function(app, $) {
    var $cache = {};

    function initializeCache() {
        $cache.body = $('body');
        $cache.facebookFooterLogo = $cache.body.find('a.logo-facebook');

        // Products
        $cache.productFiltersCtnr = $cache.body.find('div.catalog-filters');
        $cache.productFiltersList = $cache.productFiltersCtnr.find('ul');
        $cache.productFilters = $cache.productFiltersList.find('li a');
        $cache.productFiltersMobile = $cache.productFiltersCtnr.find('select');

        // Shops
        $cache.shops = $cache.body.find('div.shops div.shop-container div.shop-infos-container');
    }

    function initializeEvents() {
        $cache.facebookFooterLogo.on('click', function() {
            app.components.googleanalytics.sendEvent('FacebookClick');
        });

        // Products filters
        $cache.productFilters.on('click', function() {
            var $self = $(this);
            app.components.googleanalytics.sendEvent('ProductFilter_desktop', $self.text());
        });

        $cache.productFiltersMobile.on('change', function() {
            var $self = $(this);
            app.components.googleanalytics.sendEvent('ProductFilter_mobile', $self.find('option:selected').text());
        });

        // Shops
        $cache.shops.on('click', function() {
            var $self = $(this);
            app.components.googleanalytics.sendEvent('Shop_click', $self.find('div.text-wrapper h2').text());
        });
    }

    function initializeGoogleAnalytics() {
        (function(i, s, o, g, r, a, m) {
            i[ 'GoogleAnalyticsObject' ] = r;
            i[ r ] = i[ r ] || function() {
                    (i[ r ].q = i[ r ].q || []).push(arguments)
                }, i[ r ].l = 1 * new Date();
            a = s.createElement(o),
                m = s.getElementsByTagName(o)[ 0 ];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m)
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

        ga('create', app.preferences.googleAnalyticsCode, 'auto');

        sendPageView();
    }

    function sendPageView() {
        ga('send', 'pageview');
    }

    app.components = app.components || {};
    app.components.googleanalytics = {
        init : function() {
            if(app.preferences && app.preferences.env === 'production' && app.preferences.googleAnalyticsCode && app.preferences.modules.enableSEO) {
                initializeCache();
                initializeEvents();

                initializeGoogleAnalytics();
            }
        },

        sendEvent : function(category, action) {
            if(category) {
                ga('send', {
                    'hitType'       : 'event',
                    'eventCategory' : category.trim(),
                    'eventAction'   : action && action.trim() || ''
                });
            }
        }
    };
}(window.app = window.app || {}, jQuery));
